<!--suppress HtmlUnknownAttribute -->
<template>
  <div style="display: flex; justify-content: center; align-items: center;">

    <!-- PDF 预览对话框 -->
    <el-dialog :before-close="handleCloseDialog" :visible.sync="dialogVisible" append-to-body width="80%">
      <iframe v-if="isPdfFile" :src="dialogPdfUrl" height="600px" type="application/pdf" width="100%"></iframe>
      <el-image
          v-else
          :src="dialogImageUrl"
          fit="cover"
          style="width: 100%; height: 100%"></el-image>
    </el-dialog>

    <el-upload
        style="width: 277px"
        action="fake-action"
        :auto-upload="false"
        :before-upload="beforeUpload"
        :on-change="handleChange"
        :on-preview="handlePictureCardPreview"
        :on-remove="handleRemove"
        :accept="myAccept"
        class="upload-demo"
        drag
        :multiple="multiple"
        ref="upload">
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      <div class="el-upload__tip" slot="tip">只能上传{{ accept }}文件，且不超过10M</div>
    </el-upload>

  </div>
</template>

<script>
import {beforeUpload} from "@/assets/js/my-vue-element-ui-js";
import {utils} from "@/util/utils";


export default {
  name: "FileUpload",
  props: {
    value: {
      type: Array,
      default: () => []
    },
    accept: String,
    multiple: {
      type: Boolean,
      default: true
    },

  },

  data() {
    return {
      temp: this.value || [],
      myAccept: utils.file.getCaseInsensitiveSet(this.accept),

      dialogImageUrl: '',
      dialogVisible: false,

      isPdfFile: false,
      dialogPdfUrl: null, // 用于嵌入PDF预览的URL
    };
  },
  methods: {

    clearFiles() {
      this.$refs.upload.clearFiles();
      this.temp = [];
      this.$emit('input', this.temp);
    },


    // 修改这个方法来处理PDF预览
    async handlePictureCardPreview(file) {
      if (this.isFileTypePdf(file.name)) {
        // 如果文件是PDF
        this.isPdfFile = true;

        fileFunction.getPDFObjectUrl(file.raw).then(result => {
          this.dialogPdfUrl = result;
          this.dialogVisible = true;
        })
      } else {
        // 不是PDF文件，使用原来的逻辑

        this.dialogImageUrl = await (utils.file.getBase64(file.raw));
        this.dialogVisible = true;
      }
    },

    // 添加一个方法来检查文件类型是否为PDF
    isFileTypePdf(filename) {
      return /\.pdf$/i.test(filename);
    },

    // 当对话框关闭时，重置PDF预览相关的属性
    handleCloseDialog() {
      this.dialogVisible = false;
      this.isPdfFile = false;
      this.dialogPdfUrl = null;
    },

    // 清除所有文件
    clear() {
      this.$refs.upload.clearFiles();
    },

    beforeUpload,

    // 保存文件到列表
    handleChange(file, fileList) {
      if (utils.string.vNotEmpty(this.myAccept)) {
        // 检查文件类型
        const validTypes = this.myAccept.split(',').map(item => item.trim());
        const type = '.' + file.name.split('.').pop();
        if (!validTypes.includes(type)) {
          this.$message.error(`只能上传 ${this.myAccept} 文件`);
          return false;
        }
      }

      this.temp.push(file.raw);
      this.$emit('input', this.temp);
    },

    // 从列表移除文件
    handleRemove(file, fileList) {
      // 找到相应的文件并移除
      const index = this.temp.findIndex(f => f === file.raw);
      if (index > -1) {
        this.temp.splice(index, 1);
      }
      this.$emit('input', this.temp);
    },
  },
  watch: {
    'temp.length'() {
    },
    value: {
      deep: true,
      handler(newVal) {
        this.temp = [...newVal];
      }
    },
  }
};
</script>

<style scoped>
</style>
